import isStrictComparable from "./component-library308.mjs";
import keys from "./component-library297.mjs";
function getMatchData(object) {
  var result = keys(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}
export {
  getMatchData as default
};
